import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b27d973"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($props.href!==undefined&&!$options.isLink($props.href)&&!$props.click)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        class: _normalizeClass({point: $props.point}),
        to: $props.href
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.name), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class", "to"]))
    : ($props.href!==undefined&&$options.isLink($props.href)&&!$props.click)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          target: "_blank",
          class: _normalizeClass({point: $props.point}),
          href: $props.href
        }, _toDisplayString($props.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_1))
      : ($props.href===undefined&&$props.click)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            class: _normalizeClass({point: $props.point}),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($props.click($props.href)))
          }, _toDisplayString($props.name), 3 /* TEXT, CLASS */))
        : (_openBlock(), _createElementBlock("a", {
            key: 3,
            class: _normalizeClass({point: $props.point})
          }, _toDisplayString($props.name), 3 /* TEXT, CLASS */))
}